module.exports = __webpack_public_path__ + "static/media/Gene_X_Shorter_Length_Control_DNA.e475a138.svg";